import Vue from 'vue';

const success = (context, response) => {
  if (response.userInvoices && response.userInvoices.length > 0) {
    context.invoices = response.userInvoices;
    context.invoices.map((invoice) => {
      invoice.total_cents = (invoice.total_cents / 100).toFixed(2);
    });
  }
};

const failed = (context, error) => {
    // toastr.error(error);
};

export default context => Vue.$http.get('user/get-invoices')
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/getUserInvoices.js